import React, { useState, useEffect,useContext} from 'react';
import { useNavigate,useParams} from 'react-router-dom';
import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import InputSelect from '../../../Components/InputSelect';
import SelectBox2 from '../../../Components/Select2';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";

import { GlobalContext } from '../../../GlobalContext';

const EditGroup = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    const { groupId } = useParams();

    useEffect(() => {
        setCurrentTab('Edit group');
    });

    const token = localStorage.getItem('token');

    const callDurationArray = [
        "30s",
        "60s",
        "120s",
        "180s",
    ];

    const date = new Date();

    // Get year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;

    const [companyList, setCompanyList] = useState([]); 
    const [groupData, setGroupData] = useState({});

    useEffect(() => {
        fetchCompanyList();
        fetchGroupData();
    }, []);

    const fetchCompanyList = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/companys/get`,
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Authorization: `Bearer ${token}`, // Include the token
                },
              }
        )
        .then(response => {
            setCompanyList(response.data.data);
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }
    
    const fetchGroupData = async (companyList) => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/groups/getone`, {groupId: groupId},
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Token: token ,  // Include the token
                },
                }
        )
        .then(response => {
            // console.log('response',response.data, response.data.data.name);
            setGroupData(response.data.data);
            const data  = response.data.data;
            setSelectedCompany(data.company_id);
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }

    const handleGroupChange = (e) => {
        setGroupData({
            ...groupData,
            [e.target.name]: e.target.value,
        });
    };

    const [selectedCompany, setSelectedCompany] = useState(null);
    const changeCompany = (option) => {
        // //console.log(option,'options');
        setSelectedCompany(option);
        if(option) {
            setGroupData({
                ...groupData,
                ['company_id']: option._id,
            });
        } else {
            setGroupData({
                ...groupData,
                ['company_id']: '',
            });
        }
    };

    const gotoGroupList = () => {
        navigate(`/grouplist`); // Use navigate for routing
    };

    const handleGroupUpdate = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            if(groupData.name === "" || groupData.company_id === "") return;

            const response = await axios.post(`${POCBaseUrl}/groups/edit`, {groupId, groupData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token ,  // Include the token
                    },
                  }
            )

            if(response.data.success) {
                toast.success("Updated successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });

                setGroupData({});
                navigate('/grouplist');
            } else {
                toast.warn("Update failed!", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                });
            }

        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Company'} />
                        </div>
                        <div className={ `w-[360px] text-gray-500 bg-[transparent] text-sm tracking-wide flex items-center rounded cursor-pointer hover:!border-[#2776c3] bg-[transparent]`}>
                            <Select
                                name="companylist"
                                placeholder={"Select a company"}
                                className={`basic-multi-select w-full cursor-pointer !m-0 !p-0`}
                                classNamePrefix="select"
                                options={companyList}
                                value={selectedCompany}
                                onChange={changeCompany}
                                getOptionLabel={(option) => option.name} // Show only the label
                                getOptionValue={(option) => option._id}
                                isClearable={true}
                                styles={{
                                    control: (provided) => ({
                                    ...provided,
                                    borderColor: '#dcdfe6', // Change border color based on focus state
                                    boxShadow: 'none', // Remove default shadow
                                    '&:hover': {
                                        borderColor: '#2776c3', // Change border color on hover
                                    },
                                    }),
                                }}
                                isDisabled
                            />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select a company</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Group Name'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name = {'name'} value={groupData.name || ''} onChange={handleGroupChange} placeholder={'Please input group name'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-15 letters, numbers or characters</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[150px]'>
                            <Label text={'Notes'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px] w-[360px]'>
                            <textarea
                            placeholder="Group notes:within 100 characters"
                            className="p-4 bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                            rows="4"
                            name = {'notes'}
                            value= {groupData.notes || ''}
                            onChange={handleGroupChange}
                            ></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div className='flex mt-2.5 bg-[#f0f0f0]' style={{ fontFamily: 'Liberation Serif' }}>
                <button onClick={() => handleGroupUpdate()} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Update
                </button>
                <button onClick={gotoGroupList} className='inline-block mt-2.5 mb-2.5 ml-3 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Return to the list
                </button>
            </div>
        </>
    );
}

export default EditGroup;